import { useState } from "react";
import { Button } from "antd";
import type { ButtonProps } from "antd/es/button";
import { CheckOutlined } from "@ant-design/icons";
import styles from "./index.module.scss";
import { ConfirmModal } from "../ConfirmModal";
import { useMarkAsCompleteHooks } from "src/DigitalProtocolModule/hooks";

interface FinalizateButtonProps {
  category: "population" | "arms" | "soa" | "endpoints";
}

export function FinalizateButton({
  category,
  ...rest
}: FinalizateButtonProps & ButtonProps) {
  const { doLockOrUnlock } = useMarkAsCompleteHooks();

  const [isLoading, setIsLoading] = useState(false);
  const [isShowConfirm, setIsShowConfirm] = useState(false);

  const handleConfirmFinalize = async () => {
    try {
      let payload = {};
      switch (category) {
        case "population":
          payload = { study_population_finalize_flag: true };
          break;
        case "arms":
          payload = { arm_cohort_finalize_flag: true };
          break;
        case "soa":
          payload = { soa_finalize_flag: true };
          break;
        case "endpoints":
          payload = { endpoint_finalize_flag: true };
          break;
        default:
          break;
      }
      setIsShowConfirm(false);
      setIsLoading(true);
      const res = await doLockOrUnlock(payload, true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        {...rest}
        className={styles.primaryBtn}
        key="finalize"
        type="text"
        loading={isLoading}
        onClick={() => setIsShowConfirm(true)}
      >
        <CheckOutlined />
        Mark as complete
      </Button>

      {isShowConfirm && (
        <ConfirmModal
          visible={isShowConfirm}
          title={`Mark as complete`}
          content={`Before proceeding, please ensure that all details in the study population are accurate and complete. Once submitted, the module will be locked, and no further modifications can be made.`}
          handleCancel={() => setIsShowConfirm(false)}
          handleConfirm={handleConfirmFinalize}
        />
      )}
    </>
  );
}
